/**
 * Removes all attachments of a correlation.
 *
 * @param {Correlation} correlation
 */
export function removeAttachments(correlation) {
    correlation.attachment = {};
    return correlation;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVtb3ZlQXR0YWNobWVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbGl0aWVzL2NvcnJlbGF0aW9uL3JlbW92ZUF0dGFjaG1lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBOzs7O0dBSUc7QUFDSCxNQUFNLFVBQVUsaUJBQWlCLENBQUMsV0FBd0I7SUFDeEQsV0FBVyxDQUFDLFVBQVUsR0FBRyxFQUFFLENBQUM7SUFFNUIsT0FBTyxXQUFXLENBQUM7QUFDckIsQ0FBQyJ9